<header>
    <div class="contenedor-info-app">
        <div class="cover">
            <div class="mockup">
                <img src="../../assets/images/landing/CMI/movil_rpn.png">
            </div>
            <div class="texto">
                <h2 class="title-white" style=" font-family: poppins; font-weight: 700; color: #72C9FF;">¡Bienvenido a RPN!</h2>
                <p class="title-white" style=" font-family: poppins; font-weight: 300; font-size: 20px;">Te invitamos a conocer más sobre tu programa de salud CMI.</p>
                <div class="marcas">
                    <div class="marcasInd">  <img class="other-logos" src="../../assets/images/landing/CMI/asemsa.svg"></div>
                    <div class="marcasInd"> <img class="other-logos" src="../../assets/images/landing/CMI/cmi_invert.svg"></div>
                    <div class="marcasInd"> <img class="rpn-logo" src="../../assets/images/landing/CMI/RPN-INVERT.svg"></div>
                </div>
                <div class="btn">
                    <!--<button pButton type="button" class="ui-button-primary btn-dv" label="Ingresar" (click)="login()" style="width: 40%; padding: 1%;"></button>-->
                    <button pButton type="button" class="ui-button-primary btn-dv boton1" label="Ingresar" (click)="goToLogin()"  style="width: 40%; padding: 1%;"></button>
                </div>
            </div>
        </div>
    </div>
</header>
<section class="beneficios">
    <div class="contenedor-carne">
        <div class="cover2">
            <div class="titulo-center"><h2 class="titulo">Beneficios</h2></div>
            <div class="contenedor-beneficios">
                <div class="descripcion cuadro2">
                    <h3>Emergencia</h3>
                    <img src="../../assets/images/landing/CMI/emergency.svg" class="icon-b1">
                    <p>Con nuestra nueva acción de emergencia, puedes solicitar ayuda de inmediato y tus contactos configurados serán notificados.</p>
                </div>
                <div class="descripcion cuadro1">
                    <h3 >Red de proveedores</h3>
                    <img src="../../assets/images/landing/CMI/red.svg" class="icon-b1">
                    <p>Busca al proveedor que mejor se adapte a tus necesidades y verifica su número de teléfono, horario. dirección, tarifa por evento.</p>
                </div>
                <div class="descripcion cuadro3">
                    <h3>Autorizaciones</h3>
                    <img src="../../assets/images/landing/CMI/authorization.svg" class="icon-b2">
                    <p>Realiza un seguimiento en tiempo real del estado de tus autorizaciones, obtén un mayor detalle y descarga tu autorización en PDF.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="carne">
    <div class="contenedor-carne">
        <div class="cover2">
            <div class="img3">
                <img src="../../assets/images/landing/CMI/carne_rpn.png">
            </div>
            <div class="texto2">
                <h2 class="titulo2">Carné digital</h2>
                <p> Si no tienes tu carné físico puedes presentar tu carné digital y el proveedor con gusto te atenderá.</p>
            </div>
        </div>
    </div>
</section>
<section class="busqueda">
    <div class="contenedor-busqueda">
        <div class="cover3">
            <div class="texto">
                <h2 class="titulo"> Búsqueda Inteligente </h2>
                <p class="ph-search"> Ahora puedes hacer búsquedas específicas, por ubicaciones, zonas, tipo de especialidad.</p>
            </div>
            <div class="img5">
                <img src="../../assets/images/landing/CMI/busqueda.png">
            </div>
        </div>
    </div>
</section>
<!--
    <section class="solicitudes">
        <div class="contenedor-solicitudes">
            <div class="cover3">
                <h2 class="titulo">Servicios</h2>
                <div class="parrafo2"><p> Para contratar nuestros servicios debe completar el formulario de solicitud para ser contactado por un agente, a través de los siguientes enlaces:</p>
                </div>
                <div class="content-cuadros">
                    <div class="cuadro-ind">
                        <img src="../../assets/images/landing/CMI/person.svg" class="individual">
                        <button class="boton2" [routerLink]="['/individual']" > Solicitud persona individual </button>
                    </div>
                </div>  
            </div>  
        </div>
    </section>
-->
